/* eslint-disable unicorn/filename-case */
export const initialState = {
  items: []
}

export default (state = initialState) => state
